import { __decorate, __param } from '../../../../../../../external/tslib/tslib.es6.js';
import { IConfigurationService } from 'monaco-editor/esm/vs/platform/configuration/common/configuration.js';
import { ILoggerService } from 'monaco-editor/esm/vs/platform/log/common/log.js';
import { RequestChannelClient } from '../../../../platform/request/common/requestIpc.js';
import { IRemoteAgentService } from 'vscode/vscode/vs/workbench/services/remote/common/remoteAgentService';
import { RequestService } from '../../../../platform/request/browser/requestService.js';
import { CommandsRegistry } from 'monaco-editor/esm/vs/platform/commands/common/commands.js';

let BrowserRequestService = class BrowserRequestService extends RequestService {
    constructor(remoteAgentService, configurationService, loggerService) {
        super(configurationService, loggerService);
        this.remoteAgentService = remoteAgentService;
    }
    async request(options, token) {
        try {
            const context = await super.request(options, token);
            const connection = this.remoteAgentService.getConnection();
            if (connection && context.res.statusCode === 405) {
                return this._makeRemoteRequest(connection, options, token);
            }
            return context;
        }
        catch (error) {
            const connection = this.remoteAgentService.getConnection();
            if (connection) {
                return this._makeRemoteRequest(connection, options, token);
            }
            throw error;
        }
    }
    _makeRemoteRequest(connection, options, token) {
        return connection.withChannel('request', channel => ( new RequestChannelClient(channel)).request(options, token));
    }
};
BrowserRequestService = ( __decorate([
    ( __param(0, IRemoteAgentService)),
    ( __param(1, IConfigurationService)),
    ( __param(2, ILoggerService))
], BrowserRequestService));
CommandsRegistry.registerCommand('_workbench.fetchJSON', async function (accessor, url, method) {
    const result = await fetch(url, { method, headers: { Accept: 'application/json' } });
    if (result.ok) {
        return result.json();
    }
    else {
        throw new Error(result.statusText);
    }
});

export { BrowserRequestService };
